import { FieldSpec } from '@k2/common/k2-forms-state/types';
import { TelephonePipe } from '@k2/common/telephone/pipes/telephone.pipe';

export function telephoneFormatter(telephonePipe: TelephonePipe, field: FieldSpec): string {
  return telephonePipe.transform(field.value);
}
